import { render } from "./ViewProposedKey.vue?vue&type=template&id=fb7c54b2"
import script from "./ViewProposedKey.vue?vue&type=script&lang=js"
export * from "./ViewProposedKey.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__